var Face = (function () {
    function Face() {
    }
    return Face;
}());
export { Face };
